import { HttpClient } from '@adapters/HttpClient';
import type { LegacyDashboardClient } from '../models/LegacyDashboardClient';
import { normalizeLegacyDashboardClients } from '../utils/normalizeLegacyDashboardClients';

const ENDPOINT = '/migration/legacy-dashboard';

export class LegacyDashboardApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getDashboard(): Promise<LegacyDashboardClient[]> {
    const response = await this.httpClient.get<unknown>(ENDPOINT);
    return normalizeLegacyDashboardClients(response);
  }
}
